import { useTranslation } from "react-i18next";

import { cn } from "~/components/ui/cn";
import { ReturnIcon } from "~/components/ui/icons/return";
import { OrderTagReturn } from "~/graphql/graphql-new.gen";

import { OrderBadge } from "../order-status-badge/order-badge";
import { getOrderReturnLabelFromTag } from "../order-status-badge/order-return-badge";

export const OrderReturnBadge: React.FC<{
  isCancelled?: boolean;
  tag: OrderTagReturn;
}> = ({ isCancelled, tag }) => {
  const { t } = useTranslation();

  if (tag === OrderTagReturn.None) return null;

  return (
    <OrderBadge variant="filled" intent="bold">
      <div className="flex items-center gap-x-1">
        <ReturnIcon className="size-3.5" />
        <span className={cn({ "line-through": isCancelled })}>
          {getOrderReturnLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
